import { useState } from "react";
import { faqs } from "@/mocks/catalog";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
          <SectionHeading
            eyebrow="观影指南"
            title="关于分类与浏览的常见问题"
            description="以下是使用本页分类与筛选时最常遇到的一些疑问，点击标题即可展开查看说明。"
          />

          <div className="flex flex-col gap-3">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    isOpen ? "border-primary-300 bg-primary-50/60" : "border-background-200 bg-background-50"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => toggle(faq.id)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-background-200 text-foreground-600">
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {faq.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}